export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-flight-takeoff-line',
      title: 'One-Way &amp; Long-Stay Flights',
      description: 'Flexible tickets with change options and extra baggage allowances for UK residents relocating to Saudi Arabia.',
      features: [
        'One-way tickets to Riyadh, Jeddah, Dammam',
        'Flexible date changes without excessive penalties',
        'Baggage-friendly options for personal belongings',
        'Open-ended stay arrangements'
      ],
      image: 'https://public.readdy.ai/ai/img_res/9defca6725a7fa1be0f06147c0c56911.jpg'
    },
    {
      icon: 'ri-hotel-line',
      title: 'Temporary Accommodation (4–12 Weeks)',
      description: 'Short-to-medium-term housing in major Saudi cities while you explore neighbourhoods and settle in.',
      features: [
        'Serviced apartments in Riyadh, Jeddah, Dammam',
        'Family-friendly hotels with long-stay rates',
        'NEOM-adjacent and developing city options',
        'Comfort and stability during transition'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20serviced%20apartment%20interior%20in%20Saudi%20Arabia%2C%20spacious%20living%20room%20with%20contemporary%20furniture%2C%20bright%20natural%20light%20through%20large%20windows%2C%20clean%20minimalist%20design%2C%20welcoming%20temporary%20home%20atmosphere%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=saudi-relocation-accommodation-001&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: 'Family Relocation Planning',
      description: 'Thoughtful coordination for couples, children, elderly parents, and multi-generational households.',
      features: [
        'Family-first flight timings and connections',
        'Comfortable room configurations',
        'Paced travel after arrival',
        'Support for dependents and elderly'
      ],
      image: 'https://readdy.ai/api/search-image?query=Happy%20multi-generational%20family%20at%20modern%20airport%2C%20parents%20with%20children%20and%20grandparents%2C%20luggage%20and%20travel%20documents%2C%20warm%20family%20moment%2C%20sense%20of%20togetherness%20and%20new%20adventure%2C%20bright%20natural%20lighting%2C%20lifestyle%20photography&width=600&height=400&seq=saudi-relocation-family-001&orientation=landscape'
    },
    {
      icon: 'ri-arrow-left-right-line',
      title: 'Return &amp; Contingency Travel',
      description: 'Flexible return tickets and emergency travel options for periodic UK visits and unexpected needs.',
      features: [
        'Flexible or open return tickets to UK',
        'Emergency travel arrangements',
        'Periodic UK visits for family or education',
        'Contingency travel strategies'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20traveler%20at%20UK%20airport%20check-in%20counter%2C%20modern%20terminal%20interior%2C%20sense%20of%20flexibility%20and%20preparedness%2C%20clean%20bright%20atmosphere%2C%20business%20travel%20setting%2C%20natural%20lighting%2C%20professional%20photography&width=600&height=400&seq=saudi-relocation-return-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Comprehensive Relocation Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From flexible flights to temporary accommodation, we handle every aspect of your Saudi relocation journey
          </p>
        </div>

        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="relative h-[400px] w-full rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/10 rounded-2xl mb-6">
                  <i className={`${service.icon} text-3xl text-[#C9A961]`}></i>
                </div>

                <h3 className="text-3xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {service.title}
                </h3>

                <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                  {service.description}
                </p>

                <ul className="space-y-3">
                  {service.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start gap-3">
                      <i className="ri-check-line text-[#C9A961] text-xl mt-1"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
